export default __webpack_public_path__ + "8b3ecfe85c8e6d59ac48e340794630e5.jpg";